import * as next from '../../../types/next'
import { CONTROL_NAME } from '../../../utils/blocks/types'
import type * as current from '../../../utils/types/sharedTypes'
import type { UpBlockHandler } from '../types'
import { findBlockIdWithinStep, newId } from '../utils'

import { upCommonSettings } from './common'

export const up: UpBlockHandler<next.PVRooftopNavigatorBlock> = (
  uischema,
  _,
  journey
) => {
  if (uischema.type !== CONTROL_NAME.PV_ROOF_PLANNER_CONTROL) {
    throw new Error('Expected a valid PVRoofPlanner control')
  }

  if (!journey) {
    throw new Error('Expected a valid journey')
  }

  const references = upAvailabilityBlockReference(
    uischema.options?.relatedAvailabilityBlock,
    journey
  )

  return {
    type: next.BLOCK_TYPE.PV_ROOFTOP,
    required: false,
    settings: {
      ...upCommonSettings(uischema),
      panelLifetimeYears: uischema.options?.panelLifetimeYears
    },
    references
  }
}

export const upAvailabilityBlockReference = (
  relatedAvailabilityBlock: string,
  journey: current.Journey
) => {
  if (!relatedAvailabilityBlock) {
    return {}
  }
  const [stepNumber, blockName, ctrlName] = relatedAvailabilityBlock.split('/')

  if (ctrlName !== CONTROL_NAME.AVAILABILITY_CHECK) {
    throw new Error(
      'Found invalid block reference, must be an availability check block'
    )
  }

  const availabilityCheckBlockId = findBlockIdWithinStep(
    journey,
    // The steps are numbered starting from 1, idx should be number-1
    Number(stepNumber) - 1,
    blockName
  )

  return {
    [newId<next.ReferenceId>()]: {
      meaning: 'related-availability-check',
      referenceType: next.REFERENCED_TYPE.BLOCK,
      referenceId: availabilityCheckBlockId,
      id: availabilityCheckBlockId
    } as next.AvailabilityCheckBlockReference
  }
}
